module.exports = __webpack_public_path__ + "static/security1-37a558a82a78855dee081241120506ee.png";